import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css';
import 'animate.css/animate.compat.css';
import "./index.css";
import Vue from "vue";
import App from "./Article.vue";
import VueSocialSharing from 'vue-social-sharing';
Vue.use(VueSocialSharing);

(function () {
    "use strict";
    new Vue({
        delimiters : ['${','}'],
        render: (h) => h(App),
    }).$mount("#app");
})();


